module.exports = __webpack_public_path__ + "static/media/shoesbig2.5cd09a1a.jpg";